import React, { useEffect, useState } from "react"
import { getStorefrontPopupApplicableStyles } from "./storefrontPopupConstants"
import { replaceWithRegexMap } from "./utils"

export const StorefrontPopupCoupon = (props) => {
    const { label, currentDevice, align, clickToCopy, copiedText, deviceType, editMode} = props
    const [couponText, setCouponText] = useState(label)
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const handleCopyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(label)
            setCouponText(copiedText)
            setTimeout(() => {
                setCouponText("")
            }, 3000)
        } catch (err) {}
    }
    return (
        <>
            {deviceType[currentDevice] && <div align={align}>
                <div
                    style={getStyleSheet()}
                    onMouseEnter={() => {
                        setCouponText(clickToCopy);
                    }}
                    onMouseLeave={() => {
                        if (copiedText == couponText) {
                                setTimeout(() => {
                                setCouponText("")
                            }, 3000)
                        } else {
                            setCouponText("")
                        }
                    }}
                    onClick={() => {
                        handleCopyToClipboard()
                    }}
                >
                    <span>{couponText || label}</span>
                </div>
            </div>}
        </>
    )
}

export const StorefrontPopupText = (props) => {
    const { label, currentDevice, align, editMode, deviceType, tokenReplacementObject } = props
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const getLabelValue = () => {
        if (!editMode && tokenReplacementObject) {
            return replaceWithRegexMap(label, tokenReplacementObject)
        }
        return label
    } 
    return (
        <>
            {deviceType[currentDevice] && <div style={getStyleSheet()} align={align}>
                {getLabelValue()}
            </div>}
        </>
    )
}

export const StorefrontPopupImage = (props) => {
    const { src = "", label, currentDevice, editMode, deviceType } = props
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    if (!deviceType[currentDevice]) return null
    return (
        <img style={getStyleSheet()} src={src} alt={label || ""} />
    )
}

export const StorefrontPopupSpacing = (props) => {
    const { currentDevice, editable, editMode, deviceType } = props
    const getStyleSheet = () => {
        let styles = getStorefrontPopupApplicableStyles(currentDevice, props)
        styles.border = `${editable ? 1 : 0}px dotted #ccc`
        return styles
    }
    return (
        <>
            {deviceType[currentDevice] && <div style={getStyleSheet()}></div>}
        </>
    )
}

export const StorefrontPopupInput = (props) => {
    const { id, label = "Email", name = "emailAddress", type = "text", currentDevice, editMode, deviceType, formData, setFormData, formDataError } = props
    const [value, setValue] = useState("")
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const onChangeHandler = (e) => {
        setValue(e.target.value)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: e.target.name,
                    value: e.target.value
                }
            })
        }
    }
    return (
        <>
            {deviceType[currentDevice] && <div>
                <input
                    style={getStyleSheet()}
                    name={name}
                    value={value}
                    onChange={onChangeHandler}
                    placeholder={label}
                    type={type}
                />
                {deviceType[currentDevice] && formDataError[id] && <div className="storefront-popup-error">
                    {formDataError[id]}
                </div>}
            </div>}
        </>
    )
}

export const StorefrontPopupButton = (props) => {
    const { id, formDataError, label = "Submit", action = "none", currentDevice, align, deviceType, editMode, handleClosePopup, handleSubmitLead, handleProductSubscibe } = props
    const clickCallMap = {
        "none": null,
        "closepopup": handleClosePopup,
        "submitlead": () => {
            handleSubmitLead && handleSubmitLead(id)
        },
        "subscribe": () => {
            handleProductSubscibe && handleProductSubscibe()
        }
    }

    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }

    return (
        <>
            {deviceType[currentDevice] && <div align={align}>
                <button className='btn' onClick={false && editMode ? null : clickCallMap[action]} style={getStyleSheet()}>{label}</button>
                {formDataError && formDataError[id] && <div className="storefront-popup-error">{formDataError[id]}</div>}
            </div>}
        </>
    )
}

export const StorefrontPopupLink = (props) => {
    const { align = "center", label = "Submit", currentDevice, href = "", target = "", editMode, deviceType} = props
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    return (
        <>
            {deviceType[currentDevice] && <div align={align}>
                <a href={href ? href : ""} target={target} style={getStyleSheet()}>{label}</a>
            </div>}
        </>
    )
}

export const StorefrontPopupCloseButton = (props) => {
    const {  popupData, display = "block", handleClosePopup } = props
    const getStyleSheet = () => {
        const obj = {
            display,
            color: popupData.closeButtonColor,
            backgroundColor: popupData.closeButtonBackgroundColor
        };
        if (["topBar", "bottomBar", "left", "right"].includes(popupData.position)) {
            obj.top = "5px"
            obj.right = "5px"
        }
        return obj
    }
    return (
        <>
            <div
                className='storefront-popup-close-btn'
                style={getStyleSheet()}
                onClick={() => {
                    handleClosePopup && handleClosePopup()
                }}
            >
                <span>&times;</span>
            </div>
        </>
    )
}

export const StorefrontPopupFrequencySelect = (props) => {
    const { id, name = "frequency", currentDevice, editMode, deviceType, formData, setFormData, formDataError, subProduct, product } = props
    const [selectValue, setSelectValue] = useState("")
    const [frequency, setFrequency] = useState([])
    const getStyleSheet = () => {
        return getStorefrontPopupApplicableStyles(currentDevice, props)
    }
    const onChangeHandler = (e) => {
        setSelectValue(e.target.value)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: e.target.name,
                    value: e.target.value
                }
            })
        }
    }
    useEffect(() => {
        if (!product || !subProduct) return;
        let frequencyOptions = [];
        if (product.subscriptionOptions) {
            frequencyOptions = product.subscriptionOptions.split(",").map(opt => {
                const value = opt.trim();
                return { value, label: value };
            });
        } else if (subProduct?.cycle1_billDelay) {
            const days = `${subProduct.cycle1_billDelay} Days`;
            frequencyOptions = [{ value: days, label: days }];
        }
        setSelectValue(frequencyOptions?.[0]?.value)
        setFrequency(frequencyOptions)
        if (deviceType[currentDevice]) {
            setFormData({
                ...formData,
                [id]: {
                    name: name,
                    value: frequencyOptions?.[0]?.value
                }
            })
        }
    }, [subProduct, product]);
    return (
        <>
            {deviceType[currentDevice] && <div>
                <select
                    name={name}
                    style={getStyleSheet()}
                    onChange={onChangeHandler}
                >
                    {
                        frequency.length ?
                            frequency.map(({ label, value }) => {
                                return <option selected={value === selectValue} value={value}>{label}</option>
                            })
                        : <option value="">Select</option>
                    }
                </select>
                {deviceType[currentDevice] && formDataError && formDataError[id] && <div className="storefront-popup-error">
                    {formDataError[id]}
                </div>}
            </div>}
        </>
    )
}

export const storefrontPopupComponentMap = {
    "text": StorefrontPopupText,
    "image": StorefrontPopupImage,
    "button": StorefrontPopupButton,
    "spacing": StorefrontPopupSpacing,
    "link": StorefrontPopupLink,
    "coupon": StorefrontPopupCoupon,
    "input": StorefrontPopupInput,
    "frequency": StorefrontPopupFrequencySelect
}